/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
jQuery( document ).ready(function() {
    jQuery("<img class='header__logo-image' style='max-width: 200px;margin-bottom: 26px;' width='300' height='60' src='//cdn.shopify.com/s/files/1/0484/5630/2743/files/brazen-logo-300x60px_200x@2x.png?v=1600174744' alt='BrazenGamingChairs'>").insertBefore(".footer__block-list");
$(".click-go").click(function() {
    $('html, body').animate({
        scrollTop: $(".eapps-widget-show-toolbar").offset().top
    }, 1000);
});
   $(".live-chat-click").click(function() {
    $("#tidio-chat #button").click();
});
});
// Get the container element
var btnContainer = document.getElementById("nav-bar__inner");

// Get all buttons with class="btn" inside the container
var btns = btnContainer.getElementsByClassName("nav-bar__link");

// Loop through the buttons and add the active class to the current/clicked button
for (var i = 0; i < btns.length; i++) {
  btns[i].addEventListener("click", function() {
    var current = document.getElementsByClassName("nav-active");

    // If there's no active class
    if (current.length > 0) {
      current[0].className = current[0].className.replace(" nav-active", "");
    }

    // Add the active class to the current/clicked button
    this.className += " nav-active";
  });
}



